import React from 'react'
import arrivalFlag from '../../genericComponents/assets/arrival-flag.svg'
import ImageMarker from '../../map/markers/ImageMarker'
import SVGIcon from '../../svg/SVGIcon'
import s from './ArrivalMarkerHTML.less'
import markerGrey from './marker-fond-gris.png'

type ArrivalMarkerHTMLPropsType = {
  width?: number
  height?: number
}

const ArrivalMarkerHTML: React.FC<ArrivalMarkerHTMLPropsType> = ({ width = 31, height = 37 }) => {
  return (
    <div className={s.arrivalMarker} style={{ width, height }}>
      <ImageMarker height={height} width={width} src={markerGrey} />
      <span className={s.arrivalMarkerFlag}>
        <SVGIcon url={arrivalFlag} ssrWhite width="19" height="19" />
      </span>
    </div>
  )
}

export default ArrivalMarkerHTML
